<script>
// Task 5 (credenciais por caixa): fininho de propósito — segue a mesma
// convenção dos outros *Page.vue desta pasta (recebe `inbox`, não `inboxId`,
// pra ficar igual às demais abas em Settings.vue) e só repassa `inbox.id`
// pro componente que já existia (bankSettings/Index.vue, agora per-inbox).
import BankSettingsIndex from '../../bankSettings/Index.vue';

export default {
  components: { BankSettingsIndex },
  props: {
    inbox: { type: Object, required: true },
  },
};
</script>

<template>
  <BankSettingsIndex :inbox-id="inbox.id" />
</template>
